export const Steps = {
  VISTA: 'VISTA',
  CROP_SEG: 'CROP_SEG',
  GET_VI: 'GET_VI',
  PLOT_DOCTOR: 'PLOT_DOCTOR',
  YIELD_SCORE: 'YIELD_SCORE',
  SUMMARY: 'SUMMARY'
};

export const StepStatus = {
  PROCESSING: 'PROCESSING',
  FINISHED: 'FINISHED',
  ERROR: 'ERROR'
};

export const StepStatusMessages = {
  STARTED: 'STARTED',
  FINISHED: 'FINISHED',
  WAITING_MODIS_PROCESS: 'WAITING_MODIS_PROCESS',
  WAITING_GAIIA_PROCESS: 'WAITING_GAIIA_PROCESS',
  NO_IMAGES_ENOUGH: 'NO_IMAGES_ENOUGH',
  TIMEOUT: 'TIMEOUT',
  CANCELLED: 'CANCELLED',
  POLYGON_CONVERT_ERROR: 'POLYGON_CONVERT_ERROR',
  STOPPED_DUE_ERROR: 'STOPPED_DUE_ERROR'
};
